"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var emprace_tokenize_variables_1 = require("./emprace-tokenize-variables");
var variableEmbraceCharacters = {
    prefix: '{',
    suffix: '}',
};
exports.tokenizeVariables = emprace_tokenize_variables_1.embraceTokenizeVariables(variableEmbraceCharacters);
exports.deTokenizeVariables = function (newEmbraceCharacters) {
    return emprace_tokenize_variables_1.embraceTokenizeVariables(newEmbraceCharacters)(variableEmbraceCharacters);
};
//# sourceMappingURL=tokenize-variables.js.map